import React from "react";
import {
    Grid,
    Typography,
    IconButton,
    Box,
} from "@mui/material";
import { FaRegEdit } from "react-icons/fa";
import { FaceProductAccordianProps } from "../../../interfaces/productVariationInterface";
import Utility from "../../../utils/Utility";
import { ROUTES } from "../../../constants/routes";
import { useNavigate } from "react-router";
import { t } from "i18next";
import { Link } from "react-router-dom";
import { useAppSelector } from "../../../redux/hooks";
import ImageIcon from "@mui/icons-material/Image";


const FaceProductAccordion = (props: FaceProductAccordianProps) => {
    const { index, faceProduct,variationGroupId , limit , currentPage} = props;
    const navigate = useNavigate();
    const isDemoUser = useAppSelector((state) => state.common.demoUser) ?? false;
    const isSuperAdminDemoSeller = useAppSelector((state) => state.common.superAdminDemoSeller) ?? false;
    const editHandler = (e: React.MouseEvent<HTMLButtonElement>)=>{
        e.stopPropagation();
        navigate(ROUTES.MANAGE_VARIATION,{state : {
            variationGroupId : variationGroupId
        }});
    };

    /**
        *
        * @description - Make Product name linkable to order list page
        */ 
    const productNameLink = (name: any, id: any,isDemoUser:boolean,isSuperAdminDemoSeller:boolean) => {
        return (
            (isDemoUser || isSuperAdminDemoSeller) ? name : (<Link to={`${process.env.REACT_APP_PRODUCT_BASE_URL}/${id}.html`} target="_blank" rel="noopener noreferrer" className="Order_id_link">
                {name}
            </Link>)
        );
    };
    return (
        <Grid container spacing={2} alignItems="center" className="word_wrap_class word_break_all">
            <Grid item xs={12} sm={12} md={0.5} lg={0.5}>
                <Typography>{(currentPage - 1) * limit + index + 1}</Typography>
            </Grid>
            <Grid item xs={12} sm={12} md={1} lg={1}>
                {faceProduct?.featuredImage != "" ? 
                    <Box
                        sx={{
                            width: 55,
                            height: 55,
                        }}
                    >
                        <img
                            src={(isDemoUser || isSuperAdminDemoSeller) ? `${faceProduct?.featuredImage}` : `${faceProduct?.featuredImage}?date=${new Utility().dateTimeCache()}`}
                            style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "contain",
                            }}
                        />
                    </Box>:
                    <ImageIcon className="featuredImage" />
                }
            </Grid>
            <Grid item xs={12} sm={12} md={1.2} lg={1.2}>
                <Typography>{faceProduct?.productCode}</Typography>
            </Grid>
            <Grid item xs={12} sm={12} md={1.5} lg={1.5}>
                <Typography>{faceProduct?.cainzProductCode}</Typography>
            </Grid>
            <Grid item xs={12} sm={12} md={2.8} lg={2.8} >
                <Typography>{ productNameLink(faceProduct?.productName,faceProduct?.cainzProductCode,isDemoUser,isSuperAdminDemoSeller)}</Typography>
            </Grid>
            <Grid item xs={12} sm={12} md={1} lg={1}>
                <Typography>{faceProduct?.publicFlag=="0"?t("product_variation_list.private"):t("product_variation_list.public")}</Typography>
            </Grid>
            <Grid item xs={12} sm={12} md={1.5} lg={1.5}>
                <Typography>{faceProduct?.variationCount}</Typography>
            </Grid> 
            <Grid  item xs={12} sm={12} md={1.5} lg={1.5}>
                <Typography>{faceProduct?.lastModifiedDate}</Typography>
            </Grid>                   
            <Grid item xs={12} sm={12} md={1} lg={1}>
                <IconButton onClick={editHandler}>
                    <FaRegEdit />
                </IconButton>
            </Grid>
        </Grid>
    );
};

export default FaceProductAccordion;



        

        
